import React, { useState } from "react";
import {
  useGetProviderCompanyProfile,
  useUpdateProviderCompanyProfile,
} from "../custom-hooks/queries";
import { useParams } from "react-router-dom";
import CustomButton from "./CustomButton";

export const CompanyProfile = () => {
  const companyData = {
    id: "comp-001",
    company_type: "Public",
    annual_revenue_usd_usd: 850000000,
    number_of_employees_range: "1000-5000",
    certifications: [
      {
        id: "cert-001",
        certification_name: "ISO 9001",
      },
      {
        id: "cert-002",
        certification_name: "ISO 13485",
      },
      {
        id: "cert-002",
        certification_name: "ISO 13485",
      },
      {
        id: "cert-002",
        certification_name: "ISO 13485",
      },
      {
        id: "cert-002",
        certification_name: "ISO 13485",
      },
    ],
    other_certification: ["GMP Certified", "FDA Registered"],
    diversity_classification: [
      {
        id: "div-001",
        diversity_classification: "Woman-Owned Business",
      },
      {
        id: "div-002",
        diversity_classification: "Minority-Owned Business",
      },
    ],
    affiliated_organizations: [
      {
        id: "org-001",
        name: "Global Lab Association",
      },
      {
        id: "org-002",
        name: "Clinical Research Network",
      },
    ],
  };

  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const { data: companyProfile, isLoading } = useGetProviderCompanyProfile(id);
  const updateProfile = useUpdateProviderCompanyProfile();

  const handleEdit = () => {
    setIsEditing(true);
    setFormData(companyProfile || {});
  };

  const handleCancel = () => {
    setIsEditing(false);
    setFormData({});
  };

  const handleSave = async () => {
    try {
      await updateProfile.mutateAsync({ id, data: formData });
      setIsEditing(false);
    } catch (error) {
      console.error("Error saving profile:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (!companyProfile) {
  //   return <div>No data available</div>;
  // }

  return (
    <div className="px-4 py-6 space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-base font-semibold text-gray-700">
          Company Information
        </h2>
        {/* {!isEditing && (
          <CustomButton
            color="bg-indigo-600"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-white"
            text="Edit"
            borderRadius="0.375rem"
            onClick={handleEdit}
          />
        )} */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm font-medium text-black">Company Type</p>
          {isEditing ? (
            <input
              type="text"
              name="company_type"
              value={formData.company_type || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">{companyData.company_type}</p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Annual Revenue (USD)</p>
          {isEditing ? (
            <input
              type="text"
              name="annual_revenue_usd"
              value={formData.annual_revenue_usd || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {companyData.annual_revenue_usd || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>

        <div>
          <p className="text-sm font-medium text-black">Number of Employees</p>
          {isEditing ? (
            <input
              type="text"
              name="number_of_employees"
              value={formData.number_of_employees || ""}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          ) : (
            <p className="text-sm text-gray-700">
              {companyData.number_of_employees || "N/A"}
            </p>
          )}
          <hr className="mt-2 border-t border-gray-200" />
        </div>
      </div>

      {isEditing && (
        <div className="flex justify-end space-x-4 mt-6">
          <CustomButton
            color="bg-gray-200"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-gray-700"
            text="Cancel"
            borderRadius="0.375rem"
            onClick={handleCancel}
          />
          <CustomButton
            color="bg-indigo-600"
            size="text-sm"
            weight="font-normal"
            height="h-8"
            width="w-20"
            textColor="text-white"
            text="Save"
            borderRadius="0.375rem"
            onClick={handleSave}
          />
        </div>
      )}

      {companyData?.certifications?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">
            Certifications
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {companyData.certifications.map((cert, index) => (
              <div key={index}>
                <p className="text-sm font-medium text-black">
                  {cert.certification_name}
                </p>
                <p className="text-sm text-gray-700">
                  {/* {cert.description || "N/A"} */}
                </p>
                <hr className="mt-2 border-t border-gray-200" />
              </div>
            ))}
          </div>
        </div>
      )}

      {companyData?.other_certifications?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">
            Other Certifications
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {companyData.other_certifications.map((cert, index) => (
              <div key={index}>
                <p className="text-sm font-medium text-black">{cert.name}</p>
                <p className="text-sm text-gray-700">
                  {cert.description || "N/A"}
                </p>
                <hr className="mt-2 border-t border-gray-200" />
              </div>
            ))}
          </div>
        </div>
      )}

      {companyData?.diversity_classifications?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">
            Diversity Classifications
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {companyData.diversity_classifications.map((classif, index) => (
              <div key={index}>
                <p className="text-sm font-medium text-black">{classif.name}</p>
                <p className="text-sm text-gray-700">
                  {classif.description || "N/A"}
                </p>
                <hr className="mt-2 border-t border-gray-200" />
              </div>
            ))}
          </div>
        </div>
      )}

      {companyData?.affiliated_organizations?.length > 0 && (
        <div className="mt-6">
          <h3 className="text-sm font-medium text-gray-700 mb-2">
            Affiliated Organizations
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {companyData.affiliated_organizations.map((org, index) => (
              <div key={index}>
                <p className="text-sm font-medium text-black">{org.name}</p>
                <p className="text-sm text-gray-700">
                  {/* {org.description || "N/A"} */}
                </p>
                <hr className="mt-2 border-t border-gray-200" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
